import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CircularProgress from '@mui/material/CircularProgress';
import * as React from 'react';
import { FlexBox } from '../box';
import { styled } from '../styled';
import { Typography } from '../typography';
const RootBox = styled(FlexBox)({
    display: 'inline-flex'
});
const ProgressWrapper = styled(FlexBox)({
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
});
export const CircularProgressWithLabel = (props) => {
    const { value, ...muiProps } = props;
    const progressValue = Math.min(value ?? 0, 100);
    return (_jsxs(RootBox, { position: "relative", children: [_jsx(CircularProgress, { variant: "determinate", ...muiProps, value: progressValue }), _jsx(ProgressWrapper, { position: "absolute", vAlign: "center", hAlign: "center", children: _jsx(Typography, { variant: "caption", component: "div", color: "text.secondary", children: `${Math.round(progressValue)}%` }) })] }));
};
export { CircularProgress };
